<template>
    <v-dialog
    v-model="openModal"
    max-width="500px">
        <v-card>
            <div class="modal-header">
                <h4 class="modal-headline">{{ $page.props.lang.checkIn || "Check In" }}</h4>
                <div class="tools">
                    <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </div>
            <v-card-text>
                <v-container>
                    <div class="fields">
                        <div class="grid">
                            <div class="field-group">
                                <p class="custom-label">{{ $page.props.lang.choose_sub|| 'Choose membership' }}</p>
                                <v-select v-model="sub" :items="memberSubs" 
                                item-text="name" item-value="id" 
                                outlined dense solo flat></v-select>
                            </div>
                        </div>
                    </div>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="regular" @click="$emit('close')">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                        <v-btn @click="confirmAction()" color="primary">{{ $page.props.lang.checkIn || "Check In" }}</v-btn>
                    </v-card-actions>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "CheckinModal",
    props: {
        modal: Boolean,
        memberSubs: Array,
        lang: Object
    },
    data() {
        return {
            sub: null
        }
    },
    computed: {
        openModal: {
            get: function() {
                return this.modal
            },
            set: function() {
                this.$emit('close')
                return false
            }
        }
    },
        methods: {
            confirmAction() {
                this.$emit('checkin', {membership_id: this.sub});
            }
        }
}
</script>